import { Helmet } from 'react-helmet-async';

const defaults = {
  siteName: 'KarbonKit',
  siteUrl: 'https://www.karbonkit.com',
  image: 'https://www.karbonkit.com/og-image.png',
  locale: 'en_GB',
};

// Canonical URLs end in a slash (/docs/): that is the form the static host
// serves the pre-rendered file at (build/docs/index.html), while /docs falls
// through to the plain app shell. See scripts/prerender.
export const canonicalUrl = (path) => `${defaults.siteUrl}${path.replace(/\/?$/, '/')}`;

const SEO = ({ title, description, path = '/', schema }) => {
  const url = canonicalUrl(path);
  const fullTitle = path === '/'
    ? title
    : `${title} | ${defaults.siteName}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={defaults.image} />
      <meta property="og:site_name" content={defaults.siteName} />
      <meta property="og:locale" content={defaults.locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={defaults.image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
